import { useCallback } from 'react';
import { useRefGetter } from './useRefGetter';
export function useCombineCallback() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }

  var refGetter = useRefGetter(callbacks);
  return useCallback(function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var fns = refGetter();
    fns.forEach(function (fn) {
      fn && fn.apply(void 0, args);
    });
  }, []);
}